import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  public name = "";
  public IsDark = true;

  constructor(private storage : Storage, private router : Router,private alertController : AlertController) { 
    storage.get('my_info').then(val =>{
      if(val)
        this.name = val;
    })
  }

  ngOnInit() { }

  TabChanged(ev){
      this.router.navigate([`dashboard/${ev.detail.value}`]);
  }

  GetCurrentTab(){
    var AD = this.router.url.split('/');
    return AD[AD.length - 1];
  }

  Logout(){
    this.alertController.create({
      header: 'آیا از خروج از حساب کاربری اطمینان دارید!؟',
      message: 'تمام اطلاعات حساب کاربری از دستگاه شما پاک خواهد شد.',
      animated: true,
      cssClass: 'rtl',
      buttons: [
        {
          text: 'خیر',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {}
        }, {
          text: 'بله',
          handler: () => {
            localStorage.clear();
            this.storage.clear().then(() =>{
              document.location.href = "login"
            });
          }
        }
      ]
    }).then(a => a.present());  
  }

  ChangeTheme(){
    document.body.classList.toggle('dark', !this.IsDark);
    this.IsDark = !this.IsDark;
    localStorage.setItem("Theme", this.IsDark ? "dark" : "light");
  }

}
